// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1JyLO","dot":"styles_dot__2-SiX","sk-bouncedelay":"styles_sk-bouncedelay__3kIk-","bounce-1":"styles_bounce-1__36oKi","bounce-2":"styles_bounce-2__34rE7"};